module.exports = __webpack_public_path__ + "static/media/nozomi-arimura-icon.371037ee.jpg";